import { DropdownOption } from 'types/dropdown';

export const CHARGES_REPORT_MIN_DATE = new Date(2026, 5, 1);

export const CHARGES_REPORT_DISABLED_DATE_INFO_TEXT =
  'Reports not available, Please connect with account manager';

export enum ReportDateRangeOptionEnum {
  THIS_MONTH = 'this-month',
  LAST_MONTH = 'last-month',
  CURRENT_FINANCIAL_YEAR = 'current-financial-year',
  LAST_FINANCIAL_YEAR = 'last-financial-year',
  CUSTOM = 'custom'
}

export enum ReportTypes {
  GST = 'gst',
  SETTLEMENT = 'settlement',
  CUSTOM = 'custom',
  CHARGES = 'charges'
}

export const ReportOptions: DropdownOption[] = [
  {
    id: ReportTypes.GST,
    label: 'GST Report',
    value: ReportTypes.GST
  },
  {
    id: ReportTypes.CUSTOM,
    label: 'Collection Report',
    value: ReportTypes.CUSTOM
  },
  {
    id: ReportTypes.CHARGES,
    label: 'Transaction Charges Report',
    value: ReportTypes.CHARGES
  }
];

export enum ReportCategory {
  PAYMENT_LINK = 'payment-link',
  PAID = 'paid',
  SETTLEMENT = 'settlement',
  DUE_DATE = 'due-date'
}

export const CategoryListOption: DropdownOption[] = [
  {
    id: 'paymentLinkGenerated',
    label: 'Payment Link Generated Date',
    value: ReportCategory.PAYMENT_LINK
  },
  {
    id: 'paid',
    label: 'Paid Date',
    value: ReportCategory.PAID
  },
  {
    id: 'settlement',
    label: 'Settled Date',
    value: ReportCategory.SETTLEMENT
  },
  {
    id: 'dueDate',
    label: 'Due Date',
    value: ReportCategory.DUE_DATE
  }
];
